<template>
  <v-select v-model="value" :items="enumOptions" :item-text="`value.${locale}`" item-value="id" @input="sync" :label="label" :readonly="readonly" :placeholder="label" :rules="rules" />
</template>

<script>
import { orderBySequence } from '@/plugins/helpers'
import DefaultField from './default'

export default {
  mixins: [DefaultField],
  props: {
    enums: {
      type: Object,
      default: {},
    },
  },
  data: () => ({
    value: 'enum field'
  }),
  computed: {
    locale () {
      return this.$i18n.locale
    },
    enumOptions () {
      return Object.values(this.enums).sort(orderBySequence)
    }
  },
  methods: {
    normalize () {
      let norm = this.value.trim()
      this.value = norm
    }
  }
}
</script>
